import { queryParamsToObj } from '../../common/util';

const { emailTest } = queryParamsToObj()

const initialState = {
  verificationLocationEnabled: undefined,
  showTwoStepVerificationPromptModal: false,
  agentInfoVerificationSubmitted: false,
  agentLockedOut: false,
  alternateLockedOut: false,
  lockedOutVerificationSent: false,
  showAgentVerificationForm: false,
  lockedOutShowAgentVerificationForm: false,
  inputValidMap: new Map([
    ["phoneInput", false],
    ["emailInput", false],
    ["countryInput", false],
    ["addressInput", false],
    ["cityInput", false],
    ["stateInput", false],
    ["zipcodeInput", false]
  ]),
  emailValidationRules: {
    regex: emailTest ? "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+(?:[A-Z]{2}|com|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum)\\b" : "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?!centerfield.com|cfmemail.com|cfmext.com)([A-Za-z0-9]+.(?:[A-Z]{2}|com|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum))$",
    required: true
  },
  phoneValidationRules: {
    maxLength: 10,
    minLength: 10,
    required: true
  },
  countryValidationRules: {
    required: true
  },
  addressValidationRules: {
    maxLength: 75,
    minLength: 1,
    required: true
  },
  cityValidationRules: {
    maxLength: 75,
    minLength: 1,
    required: true
  },
  zipCodeValidationRules: {
    maxLength: 5,
    minLength: 5,
    required: true
  }
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/agent-info-verification/redux/initialState.js